var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("This is the admin subscription "+_vm._s(this.$route.params.sid)+" page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }